var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1353 -346)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1354 346)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H2A1,1,0,0,1,3,1V7A1,1,0,0,1,2,8H0A0,0,0,0,1,0,8V0A0,0,0,0,1,0,0Z",
    transform: "translate(1355 352)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 2,
    rx: 1,
    transform: "translate(1353 352)",
    fill: "#fec900"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    rx: 1,
    transform: "translate(1353 358)",
    fill: "#fec900"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicative);
export default __webpack_public_path__ + "static/media/indicative.96580675c14084f2f8bd06d7cbf05884.svg";
export { ForwardRef as ReactComponent };